import { useCallback } from 'react';

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useToast,
  ModalHeader,
  ModalFooter,
  Flex,
} from '@chakra-ui/react';

import { SubmitHandler, useForm } from 'react-hook-form';

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { useFilterModal } from '../../hooks/filterModal';

import { Select } from '../shared/Select';

interface IFilter {
  filterId: string;
}

type FilterFormData = {
  operator: string;
};

const filterFormSchema = yup.object().shape({
  operator: yup.string().required('Operador obrigatório'),
});

export function FilterModal({ filterId }: IFilter) {
  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(filterFormSchema),
  });

  const { isSubmitting, errors } = formState;

  const toast = useToast();

  const { isOpen, onClose } = useFilterModal();

  const handleFilter: SubmitHandler<FilterFormData> = useCallback(
    async ({ operator }) => {
      try {
        // TODO: Fazer a requisição para o backend buscando as configurações
      } catch (error) {
        toast({
          title: `Endereço de e-mail e/ou senha incorreta.`,
          status: 'error',
          isClosable: true,
          position: 'bottom-right',
        });
      }
    },
    [toast],
  );

  return (
    <Modal size="md" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius="xl">
        <ModalHeader color="gray.900">Opções de Filtro</ModalHeader>
        <ModalBody>
          <Flex w="100%" as="form" onSubmit={handleSubmit(handleFilter)}>
            <Select
              label="Operador"
              error={errors.operator}
              {...register('operator')}
            >
              <option value="equal">Igual a</option>
              <option value="bigger">Maior que</option>
              <option value="smaller">Menor que</option>
              <option value="multi-value">Multi-valor</option>
            </Select>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Fechar
          </Button>
          <Button type="submit" isLoading={isSubmitting}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
